import { Stack } from '@mui/material';

import { IsTemplateProvider } from '@/modules/slideEditor/textEditors/SlideEditor.promptContext';

import { PresentationTemplateSlideEditorBody } from './PresentationTemplateSlideEditor.body';
import { PresentationTemplateSlideEditorContextProvider } from './PresentationTemplateSlideEditor.context';
import { PresentationTemplateSlideEditorHeader } from './PresentationTemplateSlideEditor.header';
import { PresentationTemplateSlideEditorSidebar } from './PresentationTemplateSlideEditor.sidebar';

export function PresentationTemplateSlideEditor() {
  return (
    <PresentationTemplateSlideEditorContextProvider>
      <IsTemplateProvider>
        <Stack height="100%" overflow="hidden" width="100%">
          <PresentationTemplateSlideEditorHeader />
          <Stack direction="row" flex={1} minHeight={0} width="100%">
            <PresentationTemplateSlideEditorSidebar />
            <PresentationTemplateSlideEditorBody />
          </Stack>
        </Stack>
      </IsTemplateProvider>
    </PresentationTemplateSlideEditorContextProvider>
  );
}
